import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import FormSelect, {formSelectSizes} from '@adv-mt/mt-form-select'
import FormSelectToggle from '@adv-mt/mt-form-select-toggle'

import {ICONS_BY_SELLER_TYPE} from './config.js'

const LEGACY_WRAPPER = 'legacy'

const FormSellerType = ({
  isSelectToggle = false,
  onChange,
  overlayContentRef,
  type,
  value,
  withLabel,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {DEFAULT_SELLER_TYPE, FILTER_NAMES} = config.get('search')
  const sellerTypes = config.get('sellerTypes')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const currentValue = value || DEFAULT_SELLER_TYPE

  const FIRST_OPTION = isSelectToggle
    ? {
        literal: i18n.t('COMMON.ALL'),
        value: DEFAULT_SELLER_TYPE
      }
    : {label: i18n.t('COMMON.ALL'), id: DEFAULT_SELLER_TYPE}

  const sellerTypeOptions = sellerTypes.map(({id, label}) =>
    isSelectToggle && wrapper === LEGACY_WRAPPER
      ? {
          literal: label,
          value: id
        }
      : {
          icon: ICONS_BY_SELLER_TYPE[id],
          id,
          label: i18n.t(label)
        }
  )

  const options = [FIRST_OPTION, ...sellerTypeOptions]

  const _handleChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.SELLER_TYPE,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.SELLER_TYPE],
      value
    })
  }

  const handleChange = ({value: selectedValue}) => {
    const [firstValue] = selectedValue
    _handleChange(null, {value: firstValue})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return isSelectToggle ? (
      <FormSelectToggle
        label={i18n.t('COMMON_SELLER_TYPE')}
        onChange={_handleChange}
        options={options}
        value={currentValue}
      />
    ) : (
      <FormSelect
        label={i18n.t('COMMON_SELLER_TYPE')}
        onChange={_handleChange}
        options={options}
        size={formSelectSizes.LARGE}
        value={currentValue}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON.ALL'),
          label: i18n.t('COMMON_SELLER_TYPE'),
          name: FILTER_NAMES.SELLER_TYPE,
          options: sellerTypeOptions,
          type
        }
      ]}
      group={`${FILTER_NAMES.SELLER_TYPE}Group`}
      legend={i18n.t('COMMON_SELLER_TYPE')}
      onChange={({value}) => {
        handleChange({value: value.filter(id => id !== allSelectionsId)})
      }}
      overlayContentRef={overlayContentRef}
      placeholder={value ? sellerTypeOptions.find(({id}) => id === value)?.label : i18n.t('COMMON.ALL')}
      showLegend={withLabel}
      value={{[FILTER_NAMES.SELLER_TYPE]: [value || allSelectionsId]}}
      wrapper={wrapper}
    />
  )
}

FormSellerType.displayName = 'FormSellerType'
FormSellerType.propTypes = {
  isSelectToggle: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.number,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

const FormSellerTypeSelectToggle = props => <FormSellerType {...props} isSelectToggle />
FormSellerTypeSelectToggle.displayName = 'FormSellerTypeSelectToggle'

const FormSellerTypeSelectMemo = memo(FormSellerType)
FormSellerTypeSelectMemo.displayName = 'FormSellerTypeSelectMemo'

const FormSellerTypeSelectToggleMemo = memo(FormSellerTypeSelectToggle)
FormSellerTypeSelectToggleMemo.displayName = 'FormSellerTypeSelectToggleMemo'

export {FormSellerTypeSelectMemo as FormSellerTypeSelect, FormSellerTypeSelectToggleMemo as FormSellerTypeSelectToggle}

export default memo(FormSellerType)
